<template>
  <li class="base__item base-item">
    <div class="base-item__row">
      <svg
        class="base-item__select"
        :class="{ 
          _selected: selected, 
          _blocked: blocked,
          _unselectable: unselectable
        }"
        width="12"
        height="12"
        @click="handleChange"
      >
        <use xlink:href="#plus" />
      </svg>

      <svg
        v-if="hasFolders"
        class="base-item__open-folder"
        :class="{ _opened: opened }"
        width="14"
        height="14"
        @click="handleToggle"
      >
        <use xlink:href="#chevron" />
      </svg>

      <span class="base-item__name">{{ item.name }}</span>
    </div>

    <ul v-if="hasFolders && opened" class="base__list">
      <search-classifiers-item
        v-for="folder in item.folders"
        :key="folder.id"
        :item="folder"
        :unselectable="innerUnselectable"
        @change="onItemChange"
      />
    </ul>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SearchClassifiersItem',

  props: {
    item: {
      type: Object,
      required: true
    },
    unselectable: {
      type: Boolean,
      default: () => false
    }
  },

  data: () => ({
    opened: false
  }),

  computed: {
    ...mapGetters([
      'selectedClassifiers',
      'searchQuery'
    ]),
    hasFolders() {
      return !!this.item.folders;
    },
    selected() {
      return (
        this.selectedClassifiers.findIndex(i => this.item.id === i.id) > -1
      );
    },
    blocked() {
      return this.item.folders && !this.searchQuery.text.trim();
    },
    innerUnselectable() {
      return this.selected || this.unselectable
    }
  },

  methods: {
    handleToggle() {
      this.opened = !this.opened;
    },
    handleChange() {
      if (this.blocked || this.unselectable) return;

      this.onItemChange(!this.selected, this.item);
    },
    onItemChange(selected, item) {
      this.$store.dispatch('changeClassifiersQuery', {
        selected: this.selected,
        classifier: item
      });
    }
  }
};
</script>
